import React from 'react';

const TextQuestion = (props) => {
  const textChangeHandler = (event) => {
    props.textChanged(event.target.value, props.eval.id);
  };

  const checkboxChangeHandler = (event) => {
    props.checkboxChanged(event.target.checked, props.eval.id);
  };

  const answer = props.textAnswer.check ? '' : props.textAnswer.text;
  return (
    <div className="col-md-6 col-md-offset-3">
      <textarea type="text" className="q-text-input form-control" rows="5" value={ answer } autoFocus autoComplete="off" onChange={ textChangeHandler } />
      <div className="center">
        <label className="cannotNameAnyone">
          <input type="checkbox" name="nobody" onClick={ checkboxChangeHandler } className="cannotNameAnyoneCheckbox" value={ props.textAnswer.check } checked={ props.textAnswer.check } />
          {` ${props.lang.q_dontasnwer}`}
        </label>
      </div>
    </div>
  );
};
export default TextQuestion;
